import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "empty"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "empty__description"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "empty__image",
    style: _normalizeStyle({
      width: $props.width
    }),
    src: $options.image
  }, null, 12, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString($props.description), 1)]);
}